export default '2.5.0';